'use client';

import {
  BookingsUnavailableErrorScreen,
  ErrorScreen,
  ErrorScreenWithAccountDetails
} from 'reservations/base/components/ErrorScreen';
import { useQueryParams } from 'reservations/base/hooks/useQueryParams';

const NotFound = () => {
  const { withAccountDetails, notAcceptingBooking, phone } = useQueryParams();

  switch (true) {
    case withAccountDetails:
      return <ErrorScreenWithAccountDetails />;
    case notAcceptingBooking:
      return <BookingsUnavailableErrorScreen phoneNumber={phone} />;
    default:
      return <ErrorScreen />;
  }
};

export default NotFound;
